function fixGridBorders() {
  const grid = document.querySelector('#product-grid.tg-product-grid');
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll('.grid__item'));
  if (items.length === 0) return;

  // 全アイテムのインラインスタイルをリセット
  items.forEach(item => {
    item.style.borderRight = '1px solid #9A9695';
    item.style.borderBottom = '1px solid #9A9695';
    item.style.borderLeft = 'none';
    item.style.borderTop = 'none';
  });

  // 行ごとにグループ化
  const rows = [];
  let currentRow = [];
  let currentTop = null;

  items.forEach(item => {
    const top = Math.round(item.getBoundingClientRect().top);
    if (currentTop === null) currentTop = top;
    if (Math.abs(top - currentTop) > 2) {
      rows.push(currentRow);
      currentRow = [];
      currentTop = top;
    }
    currentRow.push(item);
  });
  if (currentRow.length > 0) rows.push(currentRow);

// 1行あたりの標準アイテム数（最も多い行の個数）を基準にする
  const fullRowLength = Math.max(...rows.map(row => row.length));

  // 各行が「満杯」の場合のみ、最後のアイテムのborder-rightを削除
  rows.forEach(row => {
    if (row.length === fullRowLength) {
      row[row.length - 1].style.borderRight = 'none';
    }
  });

  // 最終行は、満杯かどうかに関わらずborder-bottomを削除
  const lastRow = rows[rows.length - 1];
  if (lastRow) {
    lastRow.forEach(item => {
      item.style.borderBottom = 'none';
    });
  }
}

document.addEventListener('DOMContentLoaded', fixGridBorders);
window.addEventListener('resize', fixGridBorders);

/* ============================================================
   tsukigime-archive-label.js 追記分
   既存の fixGridBorders() の後に以下をまるごと追記する
   ============================================================ */

(function () {
  'use strict';

  const filterTrigger  = document.getElementById('tgFilterTrigger');
  const filterDropdown = document.getElementById('tgFilterDropdown');
  const sortTrigger    = document.getElementById('tgSortTrigger');
  const sortDropdown   = document.getElementById('tgSortDropdown');
  const overlay        = document.getElementById('tgFilterOverlay');
  const applyBtn       = document.getElementById('tgFilterApply');
  const resetBtn       = document.getElementById('tgFilterReset');
  const catAllCheck    = document.getElementById('tgCatAll');
  const tagChecks      = document.querySelectorAll('.tg-filter-checkbox--tag');

  if (!sortTrigger) return;

  /* ---- ドロップダウン開閉 ---- */
  function openFilter() {
    filterDropdown.classList.add('tg-is-open');
    overlay.classList.add('tg-is-open');
    filterTrigger.setAttribute('aria-expanded', 'true');
    closeSortDropdown();
  }

  function closeFilter() {
    filterDropdown.classList.remove('tg-is-open');
    overlay.classList.remove('tg-is-open');
    filterTrigger.setAttribute('aria-expanded', 'false');
  }

  function openSort() {
    sortDropdown.classList.add('tg-is-open');
    overlay.classList.add('tg-is-open');
    sortTrigger.setAttribute('aria-expanded', 'true');
    closeFilter();
  }

  function closeSortDropdown() {
    sortDropdown.classList.remove('tg-is-open');
    overlay.classList.remove('tg-is-open');
    sortTrigger.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    closeFilter();
    closeSortDropdown();
  }

  if (filterTrigger) {
    filterTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      filterDropdown.classList.contains('tg-is-open') ? closeFilter() : openFilter();
    });
  }

  sortTrigger.addEventListener('click', function (e) {
    e.stopPropagation();
    sortDropdown.classList.contains('tg-is-open') ? closeSortDropdown() : openSort();
  });

  /* ---- 並び替えリンクに現在のフィルターパラメータを引き継ぐ ---- */
  document.querySelectorAll('.tg-sort-option').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const sortValue = new URLSearchParams(link.search).get('sort_by');
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortValue);
      params.delete('page');
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

  overlay.addEventListener('click', closeAll);

  overlay.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---- カテゴリチェックボックスの連動 ---- */

  /* 「すべて」をチェック→個別を全部外す */
  if (catAllCheck) {
    catAllCheck.addEventListener('change', function () {
      if (this.checked) {
        tagChecks.forEach(function (cb) { cb.checked = false; });
      }
    });
  }

  /* 個別をチェック→「すべて」を外す */
  tagChecks.forEach(function (cb) {
    cb.addEventListener('change', function () {
      if (this.checked && catAllCheck) {
        catAllCheck.checked = false;
      }
      /* 個別が全部外れたら「すべて」を戻す */
      const anyChecked = Array.from(tagChecks).some(function (c) { return c.checked; });
      if (!anyChecked && catAllCheck) {
        catAllCheck.checked = true;
      }
    });
  });

  /* ---- URLパラメータから選択状態を復元 ---- */
  (function restoreFromURL() {
    const params = new URLSearchParams(window.location.search);

    /* 在庫フィルター復元 */
    if (params.get('filter.v.availability') === '1') {
      const el = document.querySelector('input[name="tg-availability"][value="in-stock"]');
      if (el) el.checked = true;
    }

    /* 価格帯フィルター復元 */
    const pMin = params.get('filter.v.price.gte');
    const pMax = params.get('filter.v.price.lte');
    if (pMin !== null || pMax !== null) {
      document.querySelectorAll('input[name="tg-price"]').forEach(function (radio) {
        if (radio.value === 'all') return;
        const parts = radio.value.split('-');
        const mMin  = (pMin === null && parts[0] === '0') || pMin === parts[0];
        const mMax  = (pMax === null && parts[1] === '') || pMax === parts[1];
        if (mMin && mMax) radio.checked = true;
      });
    }

    /* カテゴリ（タグ）フィルター復元 */
    const tagParams = params.getAll('filter.p.tag');
    if (tagParams.length > 0) {
      if (catAllCheck) catAllCheck.checked = false;
      tagChecks.forEach(function (cb) {
        if (tagParams.indexOf(cb.value) !== -1) cb.checked = true;
      });
    }
  })();

 /* ---- APPLYボタン ---- */
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      const params = new URLSearchParams(window.location.search);

      /* 価格帯 */
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      const priceRadio = document.querySelector('input[name="tg-price"]:checked');
      if (priceRadio && priceRadio.value !== 'all') {
        const parts = priceRadio.value.split('-');
        if (parts[0]) params.set('filter.v.price.gte', parts[0]);
        if (parts[1]) params.set('filter.v.price.lte', parts[1]);
      }

      /* 在庫 */
      const availRadio = document.querySelector('input[name="tg-availability"]:checked');
      if (availRadio && availRadio.value === 'in-stock') {
        params.set('filter.v.availability', '1');
      } else {
        params.delete('filter.v.availability');
      }

      /* カテゴリ（タグ）：既存のfilter.p.tagを一旦全削除して再セット */
      const newParams = new URLSearchParams();
      params.forEach(function (val, key) {
        if (key !== 'filter.p.tag') newParams.append(key, val);
      });

      const checkedTags = Array.from(tagChecks).filter(function (cb) { return cb.checked; });
      if (checkedTags.length > 0 && !(catAllCheck && catAllCheck.checked)) {
        checkedTags.forEach(function (cb) {
          newParams.append('filter.p.tag', cb.value);
        });
      }

      newParams.delete('page');
      const qs = newParams.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    });
  }

  /* ---- RESETボタン ---- */
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      const params = new URLSearchParams(window.location.search);
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      params.delete('filter.v.availability');
      params.delete('page');

      /* タグパラメータ削除 */
      const newParams = new URLSearchParams();
      params.forEach(function (val, key) {
        if (key !== 'filter.p.tag') newParams.append(key, val);
      });

      /* UIリセット */
      if (catAllCheck) catAllCheck.checked = true;
      tagChecks.forEach(function (cb) { cb.checked = false; });
      const allPrice = document.querySelector('input[name="tg-price"][value="all"]');
      if (allPrice) allPrice.checked = true;
      const allAvail = document.querySelector('input[name="tg-availability"][value="all"]');
      if (allAvail) allAvail.checked = true;

      const qs = newParams.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    });
  }

})();

/* ============================================================
   TOPページ 特集コレクション（TSUKIGIME・SHIBUYA PARCOなど）の
   行ごとの罫線制御
   ============================================================ */

function fixFeaturedGridBorders(grid) {
  const items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
  if (items.length === 0) return;

  items.forEach(item => {
    item.style.borderRight = '1px solid #9A9695';
    item.style.borderBottom = '1px solid #9A9695';
  });

  const rows = [];
  let currentRow = [];
  let currentTop = null;

  items.forEach(item => {
    const top = Math.round(item.getBoundingClientRect().top);
    if (currentTop === null) currentTop = top;
    if (Math.abs(top - currentTop) > 2) {
      rows.push(currentRow);
      currentRow = [];
      currentTop = top;
    }
    currentRow.push(item);
  });
  if (currentRow.length > 0) rows.push(currentRow);

  // 1行あたりの標準アイテム数（最も多い行の個数）を基準にする
  const fullRowLength = Math.max(...rows.map(row => row.length));

  // 各行が「満杯」の場合のみ、最後のアイテムのborder-rightを削除
  rows.forEach(row => {
    if (row.length === fullRowLength) {
      row[row.length - 1].style.borderRight = 'none';
    }
  });

  // 最終行は、満杯かどうかに関わらずborder-bottomを削除
  const lastRow = rows[rows.length - 1];
  if (lastRow) {
    lastRow.forEach(item => {
      item.style.borderBottom = 'none';
    });
  }
}

function fixAllFeaturedGrids() {
  document.querySelectorAll('ul[id^="Slider-"].tg-product-grid').forEach(fixFeaturedGridBorders);
}

document.addEventListener('DOMContentLoaded', fixAllFeaturedGrids);
window.addEventListener('resize', fixAllFeaturedGrids);

/* ---------- TOPページ スライドショー：両端チラ見せ（PCのみ・装飾用） ---------- */
(function () {
  function initSlideshowPeekPrev() {
    const wrapper = document.querySelector('.tg-slideshow-wrapper');
    if (!wrapper) return;
    const slideshow = wrapper.querySelector('slideshow-component');
    if (!slideshow) return;
    const slider = slideshow.querySelector('.slideshow.slider');
    if (!slider) return;
    const slides = slider.querySelectorAll('.slideshow__slide');

    wrapper.classList.toggle('tg-is-grid-layout', slideshow.classList.contains('page-width'));

    function syncWrapperWidth() {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      if (!isDesktop) {
        wrapper.style.maxWidth = '';
        wrapper.style.marginLeft = '';
        wrapper.style.marginRight = '';
        return;
      }
      const reference = document.querySelector('.tsukigime-category__list');
      if (reference) {
        const width = reference.getBoundingClientRect().width;
        if (width > 0) {
          wrapper.style.maxWidth = width + 'px';
          wrapper.style.marginLeft = 'auto';
          wrapper.style.marginRight = 'auto';
        }
      }
    }

    if (slides.length < 3) {
      wrapper.classList.add('tg-no-peek');
      syncWrapperWidth();
      window.addEventListener('resize', syncWrapperWidth);
      return;
    }

    let peekPrevEl = wrapper.querySelector('.tg-slideshow-peek-prev');
    if (!peekPrevEl) {
      peekPrevEl = document.createElement('div');
      peekPrevEl.className = 'tg-slideshow-peek-prev';
      const img = document.createElement('img');
      img.loading = 'eager';
      img.alt = '';
      peekPrevEl.appendChild(img);
      wrapper.appendChild(peekPrevEl);
    }

    let peekNextEl = wrapper.querySelector('.tg-slideshow-peek-next');
    if (!peekNextEl) {
      peekNextEl = document.createElement('div');
      peekNextEl.className = 'tg-slideshow-peek-next';
      const img = document.createElement('img');
      img.loading = 'eager';
      img.alt = '';
      peekNextEl.appendChild(img);
      wrapper.appendChild(peekNextEl);
    }

    function setPeekImage(el, sourceImg) {
      const img = el.querySelector('img');
      if (!img || !sourceImg) return;
      if (sourceImg.srcset) img.srcset = sourceImg.srcset;
      img.sizes = '25vw';
      img.src = sourceImg.currentSrc || sourceImg.src;
    }

    function updateVisibility() {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      let currentIndex = 0;
      slides.forEach(function (slide, index) {
        if (slide.getAttribute('aria-hidden') !== 'true') currentIndex = index;
      });

      const total = slides.length;
      const prevIndex = (currentIndex - 1 + total) % total;
      const nextIndex = (currentIndex + 1) % total;

      setPeekImage(peekPrevEl, slides[prevIndex].querySelector('img'));
      setPeekImage(peekNextEl, slides[nextIndex].querySelector('img'));

      syncWrapperWidth();

      peekPrevEl.classList.toggle('tg-is-visible', isDesktop);
      peekNextEl.classList.toggle('tg-is-visible', isDesktop);
    }

    const observer = new MutationObserver(updateVisibility);
    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });

    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  document.addEventListener('DOMContentLoaded', initSlideshowPeekPrev);
  document.addEventListener('shopify:section:load', initSlideshowPeekPrev);
})();

/* ---------- アーティストページ・展示会ページ コレクションバナーの幅をそろえる ---------- */
(function () {
  function syncCollectionHeroWidth() {
    const hero = document.querySelector('.collection-hero.collection-hero--with-image');
    const slideshow = hero ? hero.querySelector('.collection-hero__slideshow') : null;
    const reference = document.querySelector('.header.page-width');
    if (!hero || !reference) return;
    const referenceStyle = getComputedStyle(reference);
    const paddingLeft = parseFloat(referenceStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(referenceStyle.paddingRight) || 0;
    const width = reference.getBoundingClientRect().width - paddingLeft - paddingRight;
    if (width > 0) {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const slideCount = slideshow ? slideshow.querySelectorAll('.collection-hero__slide').length : 0;
      const hasPeek = isDesktop && slideCount > 1;
      const centerImageWidth = hasPeek ? width * 0.7 : width;
      const height = centerImageWidth * (940 / 1500);
      hero.style.maxWidth = width + 'px';
      hero.style.marginLeft = 'auto';
      hero.style.marginRight = 'auto';
      if (slideshow) {
        slideshow.style.width = width + 'px';
        slideshow.style.maxWidth = width + 'px';
        slideshow.style.height = height + 'px';
        slideshow.style.marginLeft = 'auto';
        slideshow.style.marginRight = 'auto';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', syncCollectionHeroWidth);
  window.addEventListener('resize', syncCollectionHeroWidth);
  document.addEventListener('shopify:section:load', syncCollectionHeroWidth);
})();

/* ---------- 展示会ページ コレクションバナー：両端チラ見せ（PCのみ・装飾用） ---------- */
(function () {
  function initCollectionHeroPeek() {
    const hero = document.querySelector('.collection-hero.collection-hero--with-image');
    if (!hero) return;
    const slidesWrapper = hero.querySelector('.collection-hero__slides');
    if (!slidesWrapper) return;
    const slides = slidesWrapper.querySelectorAll('.collection-hero__slide');
    if (slides.length < 2) return;

    let peekPrevEl = slidesWrapper.querySelector('.tg-collection-peek-prev');
    if (!peekPrevEl) {
      peekPrevEl = document.createElement('div');
      peekPrevEl.className = 'tg-collection-peek-prev';
      const img = document.createElement('img');
      img.loading = 'eager';
      img.alt = '';
      peekPrevEl.appendChild(img);
      slidesWrapper.appendChild(peekPrevEl);
    }

    let peekNextEl = slidesWrapper.querySelector('.tg-collection-peek-next');
    if (!peekNextEl) {
      peekNextEl = document.createElement('div');
      peekNextEl.className = 'tg-collection-peek-next';
      const img = document.createElement('img');
      img.loading = 'eager';
      img.alt = '';
      peekNextEl.appendChild(img);
      slidesWrapper.appendChild(peekNextEl);
    }

    function setPeekImage(el, sourceImg) {
      const img = el.querySelector('img');
      if (!img || !sourceImg) return;
      img.src = sourceImg.src;
    }

    function updateVisibility() {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      let currentIndex = 0;
      slides.forEach(function (slide, index) {
        if (slide.classList.contains('active')) currentIndex = index;
      });

      const total = slides.length;
      const prevIndex = (currentIndex - 1 + total) % total;
      const nextIndex = (currentIndex + 1) % total;

      setPeekImage(peekPrevEl, slides[prevIndex].querySelector('img'));
      setPeekImage(peekNextEl, slides[nextIndex].querySelector('img'));

      peekPrevEl.classList.toggle('tg-is-visible', isDesktop);
      peekNextEl.classList.toggle('tg-is-visible', isDesktop);
    }

    const observer = new MutationObserver(updateVisibility);
    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    window.addEventListener('resize', updateVisibility);

    const arrowSvg = '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span>';
    const prevBtn = document.getElementById('slidePrev');
    const nextBtn = document.getElementById('slideNext');
    if (prevBtn && !prevBtn.querySelector('svg')) prevBtn.innerHTML = arrowSvg;
    if (nextBtn && !nextBtn.querySelector('svg')) nextBtn.innerHTML = arrowSvg;

    updateVisibility();
  }

  document.addEventListener('DOMContentLoaded', initCollectionHeroPeek);
  window.addEventListener('resize', initCollectionHeroPeek);
  document.addEventListener('shopify:section:load', initCollectionHeroPeek);
})();